export default __webpack_public_path__ + "static/media/Pistol_4.9bf63e7e.png";